export const enableMouseDrag = (id) => {
    let position = { top: 0, left: 0, x: 0, y: 0 };
    const element = document.getElementsByClassName("ant-table-content");

    document.addEventListener("mousedown", (e) => {
        const hasHeatmapGrid = document.getElementById(id);
        if (hasHeatmapGrid && element.length && element[0] && element[0].contains(e.target)) {
            e.target.classList.add('heatmap-grabbing-cursor')
            element[0].style.userSelect = "none";
            position = {
                left: element[0].scrollLeft,
                top: element[0].scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            };

            document.addEventListener("mousemove", mouseMoveHandler(e, id));
            document.addEventListener("mouseup", () => mouseUpHandler(e, id));
        }
    });

    const mouseMoveHandler = function (e, id) {
        const hasHeatmapGrid = document.getElementById(id);
        // How far the mouse has been moved
        const dx = e.x - position.x;
        const dy = e.y - position.y;

        // Scroll the element
        if (hasHeatmapGrid) {
            element[0].scrollTop = position.top - dy;
            element[0].scrollLeft = position.left - dx;
        }
    };
    const mouseUpHandler = function (e, id) {
        // element[0].style.cursor = "gr";
        const hasHeatmapGrid = document.getElementById(id);
        if (hasHeatmapGrid) {
            e.target.classList.remove('heatmap-grabbing-cursor')
            element[0].style.removeProperty("user-select");
            document.removeEventListener("mousemove", mouseMoveHandler);
            document.removeEventListener("mouseup", mouseUpHandler);
        }
    };

}
